import { setHeader } from '@/util/set-header'
import { Button, NoticeBar, Badge, Toast, Icon, Steps } from 'antd-mobile'
import React from 'react'
import './dorm-manage.less'
import EmptyPage from './empty-page/empty-page'
import { PhotoProvider, PhotoConsumer } from 'react-photo-view'
import 'react-photo-view/dist/index.css'
// import { encryptDES, signToJson } from "@/util/des";
import moment from 'moment'
import { userInfoApi } from '@/api/sige'
import { dormDetailApi } from '@/api/sany'
import { getUrlQueryDic } from '@/util/util'
import Cookies from 'universal-cookie'
import md5 from 'md5'
const cookie = new Cookies()
const Step = Steps.Step
// pending		预订中
// sign_up		待签约
// Reject		已驳回
// expired		已失效
// cancelled	已取消
// change_bed	换房中
// bed_continue	续租中
// refund_room	退房中
// checkout	已退宿
// relet		待续租
// live		在住

export default class DormManage extends React.Component<any, any> {
  state = {
    empty: true,
    notice: '',
    detail: {
      is_sany: false,
      store_name: '',
      building_no: '',
      room_no: '',
      bed_no: '',
      property: '',
      contract_name: '',
      room_type_name: '',
      pay_type: '',
      deposit: '',
      start_day: '',
      end_day: '',
      checkin_day: '',
      imgs: [],
      bpm_process: [],
      contract_id: '',
      status: '',
      status_info: '',
      is_need_sign: false,
      reserve_manage_id: '',
      checkin_id: '',
      checkin_customer_id: '',
      id_no: '',
      is_on_job: false,
      store_contact_way: '',
      organization: '',
      store_id: '',
      electric_pay: '',
      water_pay: '',
    },
  }
  id = ''
  constructor(prop: any) {
    super(prop)
    window.scroll(0, 0)
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.emptyBtnClick = this.emptyBtnClick.bind(this)
    this.noticeBarComponent = this.noticeBarComponent.bind(this)
    this.fullPage = this.fullPage.bind(this)
    const dic = getUrlQueryDic(this.props.location.search)
    if (dic.id) {
      this.id = dic.id
    } else {
      this.id = this.props.location.state.id
    }
    this.fetchDetail()
    // 加密
    // const tmpDic = {user: 'joeal', name: '周强'}
    // const dicJson = JSON.stringify(tmpDic)
    // const desEncode = encryptDES(dicJson)
    // const strEncode = encodeURIComponent(desEncode)

    // 解密
    // const tmpJson = signToJson(strEncode)
    // console.log(tmpJson.name)
    // this.fetchDemo()
    // this.uploadFileComponent = this.uploadFileComponent.bind(this)
  }

  // uploadFileComponent() {
  //   return (
  //     <Button>
  //       <input type="file" name="myFile" id="myFile" accept="application/msword" onChange={this.fileChange}/>
  //     </Button>
  //   )
  // }

  // fileChange() {
  //   var reader = new FileReader()
  //   var files = (document.querySelector('#myFile') as any).files
  //   console.log('file', files)
  //   // reader.readAsDataURL(files[0])

  // }

  async fetchDemo() {
    const res = await userInfoApi('21005463')
    console.log('res', res)
  }

  componentDidMount() {
    setHeader({
      title: '宿舍管理',
      leftToHome: this.goHomePage,
      right: this.rightBtn(),
    })
    // this.fetchDetail()
  }

  leftClick() {
    //返回App
    const { history } = this.props
    if (history.length > 1) {
      // history.goBack()
      this.props.history.replace('/sany/dorm-list')
    } else {
      window.location.href = 'uhomeoc://thirdparty.goBack?params={type:native}'
    }
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightBtn() {
    return (
      <div>
        {this.state.detail.is_sany ? (
          // <div onClick={() => this.checkContract()} style={{color: '#e94f4f'}}>查看合同/公约</div>
          <div
            onClick={() => this.checkContract()}
            style={{ color: '#e94f4f' }}
          >
            查看{this.state.detail.contract_name}
          </div>
        ) : (
          ''
        )}
      </div>
    )
  }

  checkContract() {
    this.props.history.push({
      pathname: '/sany/sign',
      state: { contractId: this.state.detail.contract_id, isSign: false },
    })
  }

  rightPhoneComponent() {
    return (
      <img
        onClick={() => this.callPhone()}
        src="/public/assets/img/call_icon.png"
        alt=""
      />
    )
  }

  callPhone() {
    window.location.href = 'tel:' + this.state.detail.store_contact_way
  }

  async fetchDetail() {
    const id = this.id
    Toast.loading('加载中...')
    const { data } = await dormDetailApi({ id })
    Toast.hide()
    if (data.code === 'SUCCESS') {
      cookie.set('rechargeStoreId', data.data.store_id)
      const key = md5(process.env.REACT_APP_MD5_KEY + data.data.phone.trim())
      cookie.set('sany_phone_app_sign', key)
      cookie.set('sany_phone', data.data.phone)
      cookie.set('room_id', data.data.room_id)
      // cookie.set('sany_phone', '15868194226')
      this.setState({
        detail: data.data,
      })
      this.configNotice()
      this.configNav()
    }
  }

  configNav() {
    if (
      this.state.detail.property === '员工宿舍' &&
      (this.state.detail.status === 'bed_continue' ||
        this.state.detail.status === 'change_bed' ||
        this.state.detail.status === 'refund_room' ||
        this.state.detail.status === 'live' ||
        this.state.detail.status === 'relet')
    ) {
      setHeader({
        title: '宿舍管理',
        leftToHome: this.goHomePage,
        leftClick: this.leftClick,
        right: this.rightBtn(),
      })
    } else {
      setHeader({
        title: '宿舍管理',
        leftToHome: this.goHomePage,
        leftClick: this.leftClick,
      })
    }
    if (this.state.detail.status === 'pending') {
      setHeader({
        title: '宿舍管理',
        leftToHome: this.goHomePage,
        leftClick: this.leftClick,
        right: this.rightPhoneComponent(),
      })
    }
  }

  configNotice() {
    let notice = ''
    switch (this.state.detail.status) {
      case 'checkout':
        notice = '目前无在住租约，如有需要请申请预订房源~'
        break
      case 'relet':
        notice = '你的租约即将到期，为了保障正常入住，请马上申请续租哦!!!'
        break
      default:
        break
    }
    if (this.state.detail.is_on_job === false) {
      notice = '目前为离职状态，为了保证费用结算准确，请及时申请退房哦~'
    }
    this.setState({
      notice,
    })
  }

  // 空页面组件
  emptyComponent() {
    return (
      <EmptyPage
        title="您还没预订"
        brief="快去添加预订房源吧"
        btnTitle="立即添加"
        btnClick={this.emptyBtnClick}
      />
    )
  }

  emptyBtnClick() {
    console.log('empty')
    this.setState({
      empty: false,
    })
  }

  fullPage() {
    return (
      <div className="full-page">
        {this.state.notice.length > 0 ? this.noticeBarComponent() : null}
        {/* {this.uploadFileComponent()} */}
        {this.state.detail.status === 'checkout' ||
        this.state.detail.status === 'sign_up' ||
        this.state.detail.status === 'pending'
          ? null
          : this.functionComponent()}
        {this.state.detail.status === 'sign_up' && this.state.detail.is_sany
          ? this.goSignComponent()
          : null}
        {this.state.detail.status === 'pending' && this.state.detail.is_sany
          ? this.readReserveComponent()
          : null}
        {this.state.detail.status === 'relet' && this.state.detail.is_sany
          ? this.goReletComponent()
          : null}
        {this.state.detail.status === 'bed_continue' &&
        this.state.detail.is_sany
          ? this.readReletComponent()
          : null}
        {this.state.detail.status === 'checkout' && this.state.detail.is_sany
          ? this.bookComponent()
          : null}
        {this.state.detail.is_sany ? this.leaseStatusComponent() : null}
        {this.dormInfoComponent()}
        {this.state.detail.bpm_process.length > 0 ? this.flowPath() : null}
        {/* {this.cancelBottomBtn()} */}
      </div>
    )
  }

  // 滚动通知栏
  noticeBarComponent() {
    return (
      <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>
        {this.state.notice}
      </NoticeBar>
    )
  }

  // 预订房源按钮
  bookComponent() {
    return (
      <div className="component-body" onClick={() => this.bookClick()}>
        <div className="book-btn">
          <img
            src="/public/assets/img/book_add.png"
            alt=""
            style={{ width: '40px', height: '40px' }}
          />
          <span style={{ fontSize: '12px', color: '#383838' }}>预订房源</span>
        </div>
      </div>
    )
  }

  // 预订事件
  bookClick() {
    this.props.history.push({ pathname: '/sany/dorm-list' })
  }

  // 功能组件：账单 换房/续约 退房
  functionComponent() {
    return (
      <div className="component-body">
        {
          // 非三一员工只让看充值和充值历史页面
          this.state.detail.is_sany ? (
            <div className="function-body">
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('bill')}
              >
                <img
                  src="/public/assets/img/bill_icon.png"
                  alt=""
                  style={{ width: '35px', height: '35px' }}
                />
                <span style={{ fontSize: '13px', color: '#383838' }}>账单</span>
              </div>
              {this.state.detail.property === '招待所' ? (
                ''
              ) : (
                <div
                  className="between-col"
                  style={{ height: '70px' }}
                  onClick={() => this.functionClick('change')}
                >
                  <Badge dot={this.state.detail.status === 'change_bed'}>
                    <img
                      src="/public/assets/img/bill_continue.png"
                      alt=""
                      style={{ width: '35px', height: '35px' }}
                    />
                  </Badge>
                  <span style={{ fontSize: '13px', color: '#383838' }}>
                    换房
                  </span>
                </div>
              )}
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('recharge')}
              >
                <Badge dot={this.state.detail.status === 'change_bed'}>
                  <img
                    src="/public/assets/img/bill_deposit.png"
                    alt=""
                    style={{ width: '35px', height: '35px' }}
                  />
                </Badge>
                <span style={{ fontSize: '13px', color: '#383838' }}>充值</span>
              </div>
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('recharge-history')}
              >
                <Badge dot={this.state.detail.status === 'change_bed'}>
                  <img
                    src="/public/assets/img/step_start_select.png"
                    alt=""
                    style={{
                      width: '35px',
                      height: '35px',
                      transform: 'scale(0.7)',
                    }}
                  />
                </Badge>
                <span style={{ fontSize: '13px', color: '#383838' }}>
                  充值历史
                </span>
              </div>
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('checkout')}
              >
                <Badge
                  dot={this.state.detail.status === 'refund_room'}
                  size="small"
                >
                  <img
                    src="/public/assets/img/bill_checkout.png"
                    alt=""
                    style={{ width: '35px', height: '35px' }}
                  />
                </Badge>
                <span style={{ fontSize: '13px', color: '#383838' }}>退房</span>
              </div>
            </div>
          ) : (
            <div className="function-body">
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('recharge')}
              >
                <Badge dot={this.state.detail.status === 'change_bed'}>
                  <img
                    src="/public/assets/img/bill_deposit.png"
                    alt=""
                    style={{ width: '35px', height: '35px' }}
                  />
                </Badge>
                <span style={{ fontSize: '13px', color: '#383838' }}>充值</span>
              </div>
              <div
                className="between-col"
                style={{ height: '70px' }}
                onClick={() => this.functionClick('recharge-history')}
              >
                <Badge dot={this.state.detail.status === 'change_bed'}>
                  <img
                    src="/public/assets/img/step_start_select.png"
                    alt=""
                    style={{
                      width: '35px',
                      height: '35px',
                      transform: 'scale(0.7)',
                    }}
                  />
                </Badge>
                <span style={{ fontSize: '13px', color: '#383838' }}>
                  充值历史
                </span>
              </div>
            </div>
          )
        }
      </div>
    )
  }

  // 功能点击事件
  functionClick(type: string) {
    console.log(type)
    if (type === 'bill') {
      // 账单
      this.props.history.push({
        pathname: '/sany/bill',
        state: {
          customerId: this.state.detail.checkin_customer_id,
          checkinId: this.state.detail.checkin_id,
        },
      })
    } else if (type === 'recharge') {
      if (
        this.state.detail.electric_pay === '0' &&
        this.state.detail.water_pay === '0'
      ) {
        Toast.info('当前园区不支持在线充值，如需充值请联系宿舍管理员')
        return
      }
      // 充值
      // this.props.history.push({pathname: '/sany/recharge', state: {storeId: this.state.detail.store_id}})
      this.props.history.push({ pathname: '/sany/recharge' })
    } else if (type === 'recharge-history') {
      // 充值历史
      this.props.history.push({ pathname: '/sany/recharge-history' })
    } else if (type === 'checkout') {
      if (this.state.detail.status === 'change_bed') {
        Toast.info('换房中，不可操作退房哦~')
        return
      }
      if (this.state.detail.status === 'bed_continue') {
        Toast.info('续租中，不可操作退房哦~')
        return
      }
      // 退房
      this.props.history.push({
        pathname: '/sany/checkout',
        state: {
          checkinId: this.state.detail.checkin_id,
          reserveId: this.state.detail.reserve_manage_id,
        },
      })
    } else if (type === 'change') {
      if (
        this.state.detail.property === '招待所' &&
        this.state.detail.pay_type === '部门划转'
      ) {
        Toast.info('招待所扣费方式为部门划转时，不可操作换房哦~')
        return
      }
      if (this.state.detail.status === 'refund_room') {
        Toast.info('退房中，不可操作换房哦~')
        return
      }
      if (this.state.detail.status === 'bed_continue') {
        Toast.info('续租中，不可操作换房哦~')
        return
      }
      sessionStorage.removeItem('checkinId')
      sessionStorage.removeItem('customerId')
      sessionStorage.removeItem('roomObj')
      // 换房
      this.props.history.push({ pathname: '/sany/change-bed' })
      if (
        this.state.detail.checkin_id &&
        this.state.detail.checkin_id.length > 0
      ) {
        sessionStorage.setItem('checkinId', this.state.detail.checkin_id)
      }
      if (
        this.state.detail.checkin_customer_id &&
        this.state.detail.checkin_customer_id.length > 0
      ) {
        sessionStorage.setItem(
          'customerId',
          this.state.detail.checkin_customer_id,
        )
      }
    }
  }

  // 去签约
  goSignComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goSignClick()}>
            去签约
          </Button>
          <span style={{ fontSize: '12px', color: '#515151' }}>
            换房成功！新房间签约后到期可入住，马上签约吧~
          </span>
        </div>
      </div>
    )
  }

  goSignClick() {
    this.props.history.push({
      pathname: '/sany/sign',
      state: { contractId: this.state.detail.contract_id, isSign: true },
    })
  }

  // 查看预订
  readReserveComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button
            className="go-sign-btn"
            onClick={() => this.readReserveClick()}
          >
            查看预订
          </Button>
          <span style={{ fontSize: '12px', color: '#ff6600' }}>
            你的预订申请已提交~
          </span>
        </div>
      </div>
    )
  }

  readReserveClick() {
    this.props.history.push({
      pathname: '/sany/booking-detail',
      state: { id: this.state.detail.reserve_manage_id },
    })
  }

  // 查看续租
  readReletComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goReletClick()}>
            查看续租
          </Button>
          <span style={{ fontSize: '12px', color: '#ff6600' }}>
            你的续租申请已提交~
          </span>
        </div>
      </div>
    )
  }

  readReletClick() {
    this.props.history.push({
      pathname: '/sany/relet',
      state: {
        checkinId: this.state.detail.checkin_id,
        customerId: this.state.detail.checkin_customer_id,
        num: this.state.detail.id_no,
      },
    })
  }

  // 去续租
  goReletComponent() {
    return (
      <div className="component-body">
        <div className="go-sign">
          <Button className="go-sign-btn" onClick={() => this.goReletClick()}>
            去续租
          </Button>
          <span style={{ fontSize: '12px', color: '#515151' }}>
            租约即将到期，马上提交续租申请吧~
          </span>
        </div>
      </div>
    )
  }

  goReletClick() {
    this.props.history.push({
      pathname: '/sany/relet',
      state: {
        checkinId: this.state.detail.checkin_id,
        customerId: this.state.detail.checkin_customer_id,
        num: this.state.detail.id_no,
      },
    })
  }

  // 租约状态
  leaseStatusComponent() {
    let statusClassName = 'status-text '
    switch (this.state.detail.status) {
      case 'change_bed':
        statusClassName += 'changing'
        break
      case 'bed_continue':
        statusClassName += 'wait-continue'
        break
      case 'refund_room':
        statusClassName += 'checkout'
        break
      case 'pending':
        statusClassName += 'wait-sign'
        break
      case 'sign_up':
        statusClassName += 'wait-sign'
        break
      case 'live':
        statusClassName += 'liveing'
        break
      case 'relet':
        statusClassName += 'wait-continue'
        break
      default:
        statusClassName += 'invalid'
        break
    }
    return (
      <div className="component-body">
        <div className="lease-status">
          <span style={{ fontSize: '14px', color: '#515151' }}>租约状态：</span>
          <span className={statusClassName}>
            {this.state.detail.status_info}
          </span>
        </div>
      </div>
    )
  }
  // 流程
  flowPath() {
    return (
      <div className="component-body">
        <div className="dorm-info flowPath">
          <Steps direction="vertical">
            {this.state.detail.bpm_process.map(
              (
                {
                  fdCreateTime,
                  fdActionInfo,
                  fdHandlerName,
                  fdNodeName,
                  fdAuditNote,
                },
                index,
              ) => (
                <Step
                  key={index}
                  title={fdNodeName}
                  status="finish"
                  description={
                    <div>
                      <p style={{ fontSize: '14px', color: '#515151' }}>
                        {fdHandlerName} | {fdCreateTime}
                      </p>
                      <p style={{ fontSize: '14px', color: '#515151' }}>
                        操作：{fdActionInfo}
                      </p>
                      <p style={{ fontSize: '14px', color: '#515151' }}>
                        意见：{fdAuditNote}
                      </p>
                    </div>
                  }
                />
              ),
            )}
          </Steps>
        </div>
      </div>
    )
  }

  // 预订房间信息
  dormInfoComponent() {
    const startDay =
      this.state.detail.start_day.length > 5
        ? moment(this.state.detail.start_day).format('yyyy-MM-DD')
        : this.state.detail.start_day
    const endDay =
      this.state.detail.end_day.length > 5
        ? moment(this.state.detail.end_day).format('yyyy-MM-DD')
        : this.state.detail.end_day
    return (
      <div className="component-body">
        <div className="dorm-info">
          <div className="dorm-info-top">
            <span style={{ color: '#868686', fontSize: '16px' }}>
              {this.state.detail.store_name}
            </span>
            <span style={{ color: '#1b1b1b', fontSize: '14px' }}>
              {this.state.detail.building_no} {this.state.detail.room_no}{' '}
              {this.state.detail.bed_no}
            </span>
          </div>
          <div className="dorm-info-mid">
            <div className="between-row" style={{ height: '30px' }}>
              <span style={{ color: '#434343', fontSize: '13px' }}>
                入住类型：
              </span>
              <span style={{ color: '#868686', fontSize: '13px' }}>
                {this.state.detail.property}
              </span>
            </div>
            <div className="between-row" style={{ height: '30px' }}>
              <span style={{ color: '#434343', fontSize: '13px' }}>
                预订房型：
              </span>
              <span style={{ color: '#868686', fontSize: '13px' }}>
                {this.state.detail.room_type_name}
              </span>
            </div>
            {this.state.detail.status === 'pending' ? (
              <div className="between-row" style={{ height: '30px' }}>
                <span style={{ color: '#434343', fontSize: '13px' }}>
                  入住时间：
                </span>
                <span style={{ color: '#868686', fontSize: '13px' }}>
                  {this.state.detail.checkin_day}
                </span>
              </div>
            ) : (
              <div className="between-row" style={{ height: '30px' }}>
                <span style={{ color: '#434343', fontSize: '13px' }}>
                  租期：
                </span>
                <span style={{ color: '#868686', fontSize: '13px' }}>
                  {startDay}~{endDay}
                </span>
              </div>
            )}
            <div className="between-row" style={{ height: '30px' }}>
              <span style={{ color: '#434343', fontSize: '13px' }}>
                付费方式：
              </span>
              <span style={{ color: '#868686', fontSize: '13px' }}>
                {this.state.detail.pay_type}
              </span>
            </div>
            {/* {this.state.detail.pay_type === '划扣部门' ? */}
            {this.state.detail.pay_type === '部门划转' ? (
              <div className="between-row" style={{ height: '30px' }}>
                <span style={{ color: '#434343', fontSize: '13px' }}>
                  扣费部门：
                </span>
                <span style={{ color: '#868686', fontSize: '13px' }}>
                  {this.state.detail.organization}
                </span>
              </div>
            ) : null}
            {this.state.detail.deposit &&
            this.state.detail.deposit.length > 0 ? (
              <div className="between-row" style={{ height: '30px' }}>
                <span style={{ color: '#434343', fontSize: '13px' }}>
                  押金：
                </span>
                <span style={{ color: '#868686', fontSize: '13px' }}>
                  {this.state.detail.deposit}
                </span>
              </div>
            ) : null}
          </div>
          <div className="dorm-info-bottom">
            <span style={{ color: '#434343', fontSize: '13px' }}>附件：</span>
            {this.attachmentImageList()}
          </div>
        </div>
      </div>
    )
  }

  // 构建图片数组
  attachmentImageList() {
    const imgs = this.state.detail.imgs ?? []
    if (imgs.length > 0) {
      return (
        <PhotoProvider>
          {imgs.map((item, index) => (
            <PhotoConsumer key={index} src={item} intro={item}>
              <img
                src={item}
                alt=""
                style={{ width: '47px', height: '55px', marginLeft: '10px' }}
              />
            </PhotoConsumer>
          ))}
        </PhotoProvider>
      )
    }
  }

  // 取消排队按钮
  cancelBottomBtn() {
    return (
      <Button className="cancel-btn" onClick={() => this.cancelClick()}>
        取消排队
      </Button>
    )
  }

  cancelClick() {
    console.log('cancel lineup')
  }

  render() {
    return <div className="dorm-manage">{this.fullPage()}</div>
  }
}
